<h1 mat-dialog-title>{{ data.isEdit ? 'Edit User' : 'Create User' }}</h1>
<div mat-dialog-content>
  <form [formGroup]="userForm">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width" *ngIf="!data.isEdit">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phone" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Address</mat-label>
      <input matInput formControlName="address" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        <mat-option value="admin">Administrator</mat-option>
        <mat-option value="branch">Branch</mat-option>
      </mat-select>
    </mat-form-field>

    <div
      *ngIf="userForm.get('role')?.value === 'branch' && !data.isEdit"
      class="alert alert-info">
      Note: A legacy agent user will be automatically created and linked to this
      branch.
    </div>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>VAT Number</mat-label>
      <input matInput formControlName="vatNumber" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Price Per Board Erect</mat-label>
      <input matInput type="number" formControlName="pricePerBoardErect" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Price Per Board Change</mat-label>
      <input matInput type="number" formControlName="pricePerBoardChange" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option value="Active">Active</mat-option>
        <mat-option value="Inactive">Inactive</mat-option>
        <mat-option value="On Hold">On Hold</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="userForm.invalid"
    (click)="save()">
    Save
  </button>
</div>
